import React, { useEffect, useRef, useState, useReducer } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { getSpecificItemDetails, getTwoFilteredDetails } from "../../service/ProductService";
import { GET_DASHBOARD_DATA } from "../../config/ApiConstant";
import { Toast } from "primereact/toast";
import { Link } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  defaultPageRowOptions,
  defaultRowOptionsInDashboard,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { Calendar } from "primereact/calendar";
import { UserDetailAdminDashboardColumn } from "../../appconfig/DatatableSetting";
import moment from "moment";
import { dollarTemplate, wageBodyTemplate } from "../../appconfig/TemplateFieldSetting";
import { Chart } from "primereact/chart";
import { Badge } from "primereact/badge";
import { convertDate } from "../../appconfig/AppHelper";

const AdminDashboard = () => {
  document.title = "Admin Dashboard | Nexawage Payroll";
  const toast = useRef<any>(null);

  // dashboard data obj
  const [dashboardData, setDashboardData] = useState<any>();

  // page load obj
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // year obj
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<Date | null>(new Date());

  // current month year
  const [currentMonthYear, setCurrentMonthYear] = useState<Date | any>(new Date());

  // user detail list
  const [userDetailsList, setUserDetailsList] = useState<any>([]);

  // client payment pi chart start
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  // graph obj
  const [barOptions, setBarOptions] = useState<any>(null);
  const [barChartData, setBarChartData] = useState<any>(null);

  // holiday
  const [holidays, setHolidays] = useState<any>(null);
  const today = new Date();

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: ["Received", "Due Amount"],
      datasets: [
        {
          data: [300, 100],
          backgroundColor: [
            documentStyle.getPropertyValue("--blue-500"),
            documentStyle.getPropertyValue("--yellow-500"),
            // documentStyle.getPropertyValue("--green-500"),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue("--blue-400"),
            documentStyle.getPropertyValue("--yellow-400"),
            // documentStyle.getPropertyValue("--green-400"),
          ],
        },
      ],
    };
    const options = {
      cutout: "60%",
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  // for admin client payment pi chart end

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  //   useEffect to get dashboard data
  useEffect(() => {
    getDashboard();
  }, [currentMonthYear, selectedYear]);

  // get dashboard data
  const getDashboard = async (year = currentYear) => {
    try {
      const response = await getTwoFilteredDetails(GET_DASHBOARD_DATA, "year", year, "month_year", moment(currentMonthYear).format("YYYY-MM"));
      const data = response.data;

      if (data) {
        // set user list
        setUserDetailsList(data?.adminObj?.usersList);

        setDashboardData(data);
        setPageLoad(true);
      } else {
        setDashboardData({});
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // user detail template
  const userDetailTemplate = (rowData: any) => {
    return (
      <Link style={{ textDecoration: "underline", color: "blue" }} to={`/user-details/${btoa(rowData?.id)}`} state={{ monthYear: currentMonthYear }}>
        {rowData.unique_id}
      </Link>
    );
  };

  return (
    <>
      <AppBreadcrumb pageTitle="Dashboard" pageName="Dashboard" currentMenu="Admin" />
      <Toast ref={toast} />
      <div className="layout-dashboard">
        <>
          <div className="grid mt-2">
            {/* total user */}
            <div className="col-12 md:col-6 lg:col-4">
              <Link to="/users">
                <div className="card dashbaord-main-box">
                  <div className="small-box bg-info">
                    <div className="inner" style={{ borderLeft: "3px solid #dc3545" }}>
                      <div className="flex flex-column justify-content-between">
                        <h2 className="mb-1 title-text">Total Users</h2>
                        <div className="flex align-items-center justify-content-between">
                          <h3 className="mt-0 mb-0 num-text" style={{ color: "#dc3545" }}>
                            {pageLoad ? (
                              !window.cn(dashboardData) && !window.cn(dashboardData.user_count) ? (
                                dashboardData.user_count
                              ) : (
                                ""
                              )
                            ) : (
                              <Skeleton width="5rem" height="2.5rem" className="rounded" />
                            )}
                          </h3>
                          <div
                            className="dashboard-icon"
                            style={{
                              padding: "0.35rem",
                              backgroundColor: "#f8d7da",
                              borderRadius: "9999px",
                              color: "#dc3545",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="lucide lucide-users"
                            >
                              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                              <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                              <circle cx="9" cy="7" r="4" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* total clients */}
            <div className="col-12 md:col-6 lg:col-4">
              <Link to="/clients">
                <div className="card dashbaord-main-box">
                  <div className="small-box bg-info">
                    <div className="inner" style={{ borderLeft: "3px solid #b235b6" }}>
                      <div className="flex flex-column justify-content-between">
                        <h2 className="mb-1 title-text">Total Clients</h2>
                        <div className="flex align-items-center justify-content-between">
                          <h3 className="mt-0 mb-0 num-text" style={{ color: "#b235b6" }}>
                            {pageLoad ? (
                              !window.cn(dashboardData.client_count) ? (
                                dashboardData.client_count
                              ) : (
                                ""
                              )
                            ) : (
                              <Skeleton width="5rem" height="2.5rem" className="rounded" />
                            )}
                          </h3>
                          <div
                            className="dashboard-icon"
                            style={{
                              padding: "0.35rem",
                              backgroundColor: "#e4d1e5",
                              borderRadius: "9999px",
                              color: "#b235b6",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="lucide lucide-building2"
                            >
                              <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                              <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                              <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                              <path d="M10 6h4" />
                              <path d="M10 10h4" />
                              <path d="M10 14h4" />
                              <path d="M10 18h4" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* total employees */}
            <div className="col-12 md:col-6 lg:col-4">
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #0d6efd" }}>
                    <div className="flex flex-column justify-content-between">
                      <h2 className="mb-1 title-text">Total Employees</h2>
                      <div className="flex align-items-center justify-content-between">
                        <h3 className="mt-0 mb-0 num-text" style={{ color: "#0d6efd" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.emp_count) ? (
                              dashboardData.emp_count
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h3>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#e7f0ff",
                            borderRadius: "9999px",
                            color: "#0d6efd",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-user-check"
                          >
                            <path d="m16 11 2 2 4-4" />
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* user payment detail table */}
          <div className=" mt-0 bg-white p-4" style={{ borderRadius: "10px" }}>
            <div className="card-header flex justify-content-between">
              <h4 className="p-0 pb-3 m-0">User Payment Overview</h4>

              <div className="flex" style={{ flexDirection: "column" }}>
                <label className="text-center mb-1" style={{ fontWeight: 600 }}>
                  Billing Month:{" "}
                </label>

                <Calendar
                  value={currentMonthYear}
                  onChange={(e) => setCurrentMonthYear(e.value)}
                  view="month"
                  dateFormat="mm/yy"
                  placeholder="Select Month/Year"
                  showIcon
                  className=""
                />
              </div>
            </div>

            <div className=" grid col-12 md:col-12  ">
              {/* current month amount */}
              <div className="col-12 md:col-3 lg:col-3">
                <div className="card dashbaord-main-box">
                  <div className="small-box bg-info">
                    <div className="inner" style={{ borderLeft: "3px solid #35b653" }}>
                      <div className="flex flex-column justify-content-between ">
                        <h5 className="mb-1" style={{ fontSize: "15px" }}>
                          Selected Month Total Amount
                        </h5>
                        <div className="flex align-items-center justify-content-between">
                          <h5 className="mt-0 mb-0" style={{ color: "#35b653" }}>
                            {pageLoad ? (
                              !window.cn(dashboardData.adminObj) ? (
                                `$${dashboardData?.adminObj?.currentMonthTotal}`
                              ) : (
                                ""
                              )
                            ) : (
                              <Skeleton width="5rem" height="2.5rem" className="rounded" />
                            )}
                          </h5>
                          <div
                            className="dashboard-icon"
                            style={{
                              padding: "0.35rem",
                              backgroundColor: "#e8fff2",
                              borderRadius: "9999px",
                              color: "#35b653",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="lucide lucide-dollar-sign-circle"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <path d="M12 6v12" />
                              <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* upcomming month amount */}
              <div className="col-12 md:col-3 lg:col-3">
                <div className="card dashbaord-main-box">
                  <div className="small-box bg-info">
                    <div className="inner" style={{ borderLeft: "3px solid #e9cf24" }}>
                      <div className="flex flex-column justify-content-between ">
                        <h5 className="mb-1" style={{ fontSize: "15px" }}>
                          Upcoming Month Total Amount
                        </h5>
                        <div className="flex align-items-center justify-content-between">
                          <h5 className="mt-0 mb-0" style={{ color: "#e9cf24" }}>
                            {pageLoad ? (
                              !window.cn(dashboardData.adminObj) ? (
                                `$${dashboardData?.adminObj?.upcomingMonthTotal}`
                              ) : (
                                ""
                              )
                            ) : (
                              <Skeleton width="5rem" height="2.5rem" className="rounded" />
                            )}
                          </h5>
                          <div
                            className="dashboard-icon"
                            style={{
                              padding: "0.35rem",
                              backgroundColor: "#fff8c9",
                              color: "#e9cf24",
                              borderRadius: "9999px",
                              width: "40px",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="lucide lucide-dollar-sign-circle"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <path d="M12 6v12" />
                              <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Heighest paying user */}
              {/* <div className="col-12 md:col-3 lg:col-3">
                <div className="card dashbaord-main-box">
                  <div className="small-box bg-info">
                    <div
                      className="inner"
                      style={{ borderLeft: "3px solid #a124e9" }}
                    >
                      <div className="flex flex-column justify-content-between ">
                        <h5 className="mb-1" style={{ fontSize: "15px" }}>
                          Highest Paying User
                        </h5>
                        <div className="flex align-items-center justify-content-between">
                          <h5
                            className="mt-0 mb-0"
                            style={{ color: "#a124e9" }}
                          >
                            {pageLoad ? (
                              !window.cn(dashboardData.adminObj) ? (
                                `Navtej Singh`
                              ) : (
                                ""
                              )
                            ) : (
                              <Skeleton
                                width="5rem"
                                height="2.5rem"
                                className="rounded"
                              />
                            )}
                          </h5>
                          <div
                            className="dashboard-icon"
                            style={{
                              padding: "0.35rem",
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "#a124e9",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            $32213232.32
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="col-12 md:col-12">
              <Card className=" bg-white payment-detail-table " style={{ boxShadow: "0px 0px 6px 2px #d8dde6" }}>
                <div className="card-header mb-3 flex justify-content-between">
                  <h5 className="font-bold text-gray-700 mb-0">User Charge List</h5>
                </div>
                {pageLoad ? (
                  <DataTable
                    className="datatable-responsive p-datatble-sm"
                    value={userDetailsList}
                    responsiveLayout={"scroll"}
                    // showGridlines
                    // stripedRows
                    dataKey="id"
                    paginator={userDetailsList?.length > 0}
                    rowsPerPageOptions={defaultPageRowOptions}
                    rows={defaultRowOptionsInDashboard}
                    paginatorTemplate={paginatorLinks}
                    currentPageReportTemplate={showingEntries + " Users"}
                    emptyMessage="No User Found"
                    rowHover
                  >
                    {UserDetailAdminDashboardColumn.map((col: any, i: any) => {
                      if (col.field === "name") {
                        return <Column key={col.field} field={col.field} header={col.header} />;
                      } else if (col.field === "unique_id") {
                        return <Column key={col.field} field={col.field} header={col.header} body={userDetailTemplate} />;
                      } else if (col.field === "total_client_charge") {
                        return <Column key={col.field} field={col.field} header={col.header} body={dollarTemplate} />;
                      } else {
                        return <Column key={col.field} field={col.field} header={col.header} />;
                      }
                    })}
                  </DataTable>
                ) : (
                  <DataTable value={Skeletonitems}>
                    {UserDetailAdminDashboardColumn.map((col: any) => (
                      <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                    ))}
                  </DataTable>
                )}
              </Card>
            </div>
          </div>

          {/* pi chart for clients payment in admin  */}
          {/* <div className="grid mt-4">
            <div className="col-12 md:col-3">
              <div className=" new-overview-boxes ">
                <div className="card overview-details">
                  <span className="overview-text-h">
                    Clients Pay Cycle Payment
                  </span>
                  <div className="flex justify-content-center">
                    {!chartData || !chartOptions ? (
                      <Skeleton width="300px" height="300px" shape="circle" />
                    ) : (
                      <Chart
                        type="doughnut"
                        data={chartData}
                        options={chartOptions}
                        className="w-full md:w-30rem"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* chart start */}

          {/* <div className="col-12 md:col-12 p-0 flex mt-4">
            <div className="col-12 md:col-9">
              <div className="card widget-revenue-graph mb-0">
                <div className="card-header mb-1">
                  <span className="overview-text-h">Gross Payment</span>
                  <Calendar
                    id="year"
                    value={selectedYear}
                    onChange={(e) => {
                      if (e.value instanceof Date) {
                        setSelectedYear(e.value);
                      } else {
                        setSelectedYear(null);
                      }
                    }}
                    view="year"
                    dateFormat="yy"
                    showIcon
                    className="w-auto"
                    placeholder="Select Year"
                  />
                </div>

                <div className="graph">
                  {pageLoad ? (
                    barChartData ? (
                      <Chart
                        type="line"
                        id="gross-chart"
                        data={barChartData}
                        options={barOptions}
                        style={{ maxHeight: "50vh" }}
                      ></Chart>
                    ) : (
                      <div className="flex gap-1 p-4 align-items-center flex-column justify-content-center ">
                        <img
                          src="https://res.cloudinary.com/dpc2muwar/image/upload/v1753697918/no-datas_voktda.png"
                          alt=""
                          width="120"
                          height="120"
                          style={{ marginBottom: "-8px" }}
                        />
                        <p className="text-gray-500">
                          No Gross Payment data available for the selected year.
                        </p>
                      </div>
                    )
                  ) : (
                    <Skeleton
                      height="300px"
                      className="mt-3 mb-3 border-round"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 md:col-3 new-overview-boxes">
              <div className="card widget-overview-box widget-overview-box-1">
                {!window.cn(holidays) && !window.cn(holidays?.today) && (
                  <>
                    <span className="overview-title">Holidays</span>
                    <div className="overview-details mt-2">
                      <div className="overview-text-h">
                        Today is {holidays?.today?.festival}{" "}
                      </div>
                    </div>
                  </>
                )}
                <div className="overview-details mt-2">
                  <div className="overview-text-h upcoming-holidays mb-2">
                    Upcoming Holidays
                  </div>
                  {!window.cn(holidays) && !window.cn(holidays?.upcoming) ? (
                    <div className="grid">
                      {holidays?.upcoming.length > 0 &&
                        holidays?.upcoming.map((item: any, index: any) => (
                          <div
                            className={`col-12 md:col-6 pb-0 ${
                              index % 2 === 0 ? "" : "justify-content-end"
                            }`}
                            key={index}
                          >
                            <div className="holiday-name">{item?.festival}</div>
                            <div className="holidaye-date text-end">
                              {convertDate(item?.date)}
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <span>No Upcomming Holiday Found..!!</span>
                  )}
                </div>
              </div>
            </div>
          </div> */}
          {/* chart end */}
        </>
      </div>
    </>
  );
};

export default AdminDashboard;
